/**
 * Shared "keep password managers off this input" attribute bag.
 *
 * This is the web/app-home copy. There is a deliberate duplicate at
 * `mini-apps/_shared/autofill.ts` — mini-apps cannot import from
 * web/app-home/** (an oxlint-enforced boundary; see the
 * `no-restricted-imports` rule in `mini-apps/.oxlintrc.json`), so each isolated system
 * carries its own copy rather than sharing one across the boundary — the
 * same reason the operator catalogs are duplicated across the two systems.
 * Keep the two files in sync by hand; see `docs/autofill-ignore-inputs.md`
 * for the full sweep convention and the `terra/input-autofill-ignore` lint
 * rule that flags un-swept inputs.
 */

/** Keep password managers from decorating text-like value inputs —
 * Dashlane et al. pattern-match them (card-expiry/birthday/login shapes)
 * and overlay an autofill icon on top of the native control. Each vendor
 * honors its own opt-out: `data-form-type="other"` is Dashlane's, the rest
 * cover 1Password / LastPass / Bitwarden. */
export const AUTOFILL_IGNORE_PROPS = {
  autoComplete: 'off',
  'data-form-type': 'other',
  'data-1p-ignore': '',
  'data-lpignore': 'true',
  'data-bwignore': '',
} as const;
